module.exports = __webpack_public_path__ + "static/media/DMG-Light.b6c5d1e1.webp";